import React,{ useEffect, useState, useContext } from "react";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import Repo from "../../Utility/Repo";
import ModalComponent from "../../Components/ModalComponent";
import Loader from "../../Components/Loader";
import { TokenContext } from "../../Components/TokenContext";
import Pagination from "../../Components/Pagination";
import TabellaIsee from "../../Components/TabellaIsee";

function ListRanges(props) {
  const apiToken = useContext(TokenContext);
  const [rangesList, setRangesList] = useState([]);
  const [rangesListTemp, setRangesListTemp] = useState();
  const [isOpen, toggleModal] = useState(false);
  const [removableRange, setRemovableRange] = useState("");
  const [isAlertVisible, setIsAlertVisible] = useState(false);
  const [loading, setLoading] = useState(true);

 

  useEffect(() => {
    setLoading(false);
    Repo.getRangesList(apiToken)
      .then((response) => {
        setRangesListTemp(response.data);
        setLoading(true);
      })
      .catch((error) => {
        console.log(error);
        setLoading(true);
      });
  }, []);



  const editRange = (rangeId) => {
    window.location.href =
      props.subfolder + "/fasce/modifica_fascia?range=" + rangeId;
  };

  const removeRangeAPI = () => {
    Repo.postDeleteRange(apiToken, removableRange)
      .then((response) => {
        if (response.status == 200 || response.status == 204) {
          setRemovableRange("");
          window.location.href = props.subfolder + "/fasce";
        }
      })
      .catch((error) => {
        console.log(error);
        setRemovableRange("");
        setIsAlertVisible(true);
      });
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsAlertVisible(false);
    }, 4000);
    return () => clearTimeout(timer);
  }, [isAlertVisible]);

  return (
    <>
      <div>
        <h1>Fasce ISEE</h1>
<div className="row">
<div className="clearfix col-8 py-lg-2">
          <p>Tutte le fasce ISEE inserite sul sistema. Queste fasce verranno sucessivamente associate ad un bando. Cliccare un bottone "Nuova Fascia" per crearne una nuova.</p>
          </div>

          
          <div className="col-4 clearfix">
            <button
              type="button"
              className="btn btn-outline-primary float-right p-2"
              onClick={() =>
                (window.location.href =
                  window.location.pathname + "/nuova_fascia")
              }
            >
              <svg className="icon icon-primary">
                <use href={`${iconSprite}#it-plus-circle`} />
              </svg>{" "}
              <span className="align-middle">Nuova Fascia</span>
            </button>
          </div>
       

</div>




        <div className="container">
  {/* HEADER */}
  <div className="row font-weight-bold py-2">
    <div className="col-6">Nome</div>
    <div className="col">Da</div>
    <div className="col">A</div>
    <div className="col">%</div>
    <div className="col">Quota</div>
    <div className="col text-right"></div>
  </div>

  {/* CONTENUTO */}
  {rangesList && rangesList.length > 0 ? (
    rangesList.map((x, index) => (
      <div key={index} className="row align-items-center border-bottom py-2">
        {/* Nome */}
        <div className="col-6">
          <strong>{x.name}</strong>
        </div>

        {/* Da */}
        <div className="col">
          {parseFloat(x.min).toLocaleString("it-IT")} €
        </div>

        {/* A */}
        <div className="col">
          {parseFloat(x.max).toLocaleString("it-IT")} €
        </div>

        {/* % */}
        <div className="col">
          {x.percent ? x.percent + "%" : "N/A"}
        </div>

        {/* Quota */}
        <div className="col">
          {x.fixedCost ? parseFloat(x.fixedCost).toLocaleString("it-IT") + " €" : "-"}
        </div>

        {/* Azioni */}
        <div className="col text-right">
          <button
            className="btn btn-outline-primary p-1 mx-1"
            title="Dettaglio"
            onClick={() => editRange(x.id)}
          >
            <svg className="icon icon-primary">
              <use href={`${iconSprite}#it-search`} />
            </svg>
          </button>
          <button
            className="btn btn-outline-danger p-1"
            type="button"
            title="Elimina"
            onClick={() => {
              toggleModal(!isOpen);
              setRemovableRange(x.id);
            }}
          >
            <svg className="icon icon-danger">
              <use href={`${iconSprite}#it-delete`} />
            </svg>
          </button>
        </div>
      </div>
    ))
  ) : (
    <div className="text-center py-3">
      <b>Non sono presenti range</b>
    </div>
  )}

  {/* PAGINAZIONE */}
  {rangesListTemp && (
    <div className="p-2"><Pagination items={rangesListTemp} setCurrentItems={setRangesList} itemsPerPage={20} /></div>
  )}
</div>



      </div>
      <ModalComponent
        toggleModal={toggleModal}
        isOpen={isOpen}
        header={"Rimozione Fascia ISEE"}
        body={"Confermi di voler rimuovere la fascia ISEE selezionata?"}
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => removeRangeAPI()}
      ></ModalComponent>
      {isAlertVisible && (
        <>
          <div
            className="alert alert-danger"
            role="alert"
            style={{
              position: "fixed",
              bottom: 0,
              right: "15px",
              backgroundColor: "#fff",
              width: "22%",
              zIndex: 10000,
            }}
          >
            <b>La fascia ISEE selezionata è inclusa in un bando in corso.</b>
          </div>
        </>
      )}
      {!loading && <Loader></Loader>}
    </>
  );
}

export default ListRanges;
